export const LANGUAGE_MAP = {
  python: { key: "python", displayName: "Python" },
  c: { key: "c", displayName: "C" },
  cplusplus: { key: "cplusplus", displayName: "C++" },
  csharp: { key: "csharp", displayName: "C#" },
  ruby: { key: "ruby", displayName: "Ruby" },
  java: { key: "java", displayName: "Java" },
  javascript: { key: "javascript", displayName: "JavaScript" },
  shell: { key: "shell", displayName: "Shell" },
  swift: { key: "swift", displayName: "Swift" },
  php: { key: "php", displayName: "PHP" },
  julia: { key: "julia", displayName: "Julia" },
  kotlin: { key: "kotlin", displayName: "Kotlin" },
  golang: { key: "golang", displayName: "Go" },
  r: { key: "r", displayName: "R" },
  haskell: { key: "haskell", displayName: "Haskell" },
  rust: { key: "rust", displayName: "Rust" },
  typescript: { key: "typescript", displayName: "TypeScript" },
  scala: { key: "scala", displayName: "Scala" },
  "objective-c": { key: "objective-c", displayName: "Objective-C" },
} as const;

const LANGUAGE_DISPLAY_NAME_KEY_TO_MAP: {
  [key: string]: string;
} = Object.entries(LANGUAGE_MAP).reduce(
  (languageMap, [key, { displayName }]) => {
    languageMap[displayName] = key;
    return languageMap;
  },
  {}
);

export const getLanguageDisplayNameByKey = (key: string) => {
  return LANGUAGE_MAP[key]?.displayName;
};

export const getLanguageKeyByDisplayName = (displayName: string) => {
  return LANGUAGE_DISPLAY_NAME_KEY_TO_MAP[displayName];
};
